module.exports = __webpack_public_path__ + "img/movingboard_.25b1eb26.jpeg";